import React, { useEffect, useState } from "react";
import { NavigationDropdown } from "./menu-dropdown.styles";
import {
  Bars,
  Circle,
  HexagonLeft,
  HexagonRight,
  Triangle,
} from "../figures/figures";
import MenuItem from "../menu-item/menu-item.component.jsx";
import { useSelector } from "react-redux";
import { findIndex, cloneDeep, filter } from "lodash";
import { STORAGE_IMAGE_URL } from '../../constants/storage';

const logoSmall = `${STORAGE_IMAGE_URL}/menu/logo-small-icon.svg`;
const walmartIcon = `${STORAGE_IMAGE_URL}/menu/walmart-spark-icon.png`;
const amazonIcon = `${STORAGE_IMAGE_URL}/menu/amazon-icon.png`;
const shopifyIcon = `${STORAGE_IMAGE_URL}/menu/shopify-icon.png`;
const agencyIcon = `${STORAGE_IMAGE_URL}/menu/agency-icon.png`;
const wholesaleIcon = `${STORAGE_IMAGE_URL}/menu/wholesale-icon.png`;
const twoDWorkflowIcon = `${STORAGE_IMAGE_URL}/menu/2d-workflow-icon.png`;
const inventoryManagementIcon = `${STORAGE_IMAGE_URL}/menu/inventory-management-icon.png`;
const settingsIcon = `${STORAGE_IMAGE_URL}/menu/settings-icon.png`;
const distribution = `${STORAGE_IMAGE_URL}/menu/distribution-icon.png`;
const threePLFulfillment = `${STORAGE_IMAGE_URL}/menu/3pl-fulfillment-icon.png`;
const wmsFeatures = `${STORAGE_IMAGE_URL}/menu/wms-features-icon.png`;
const returnsAndRemovals = `${STORAGE_IMAGE_URL}/menu/return-removals-icon.png`;
const threePLTools = `${STORAGE_IMAGE_URL}/menu/3pl-tools-icon.png`;

const initialMenuContent = [
  {
    icon: agencyIcon,
    title: "Agency",
    tabs: [
      { title: "User Access", link: "/affiliate", reducers: ["affiliate"] },
      // {
      //   title: "Settings",
      //   link: "/affiliate/account-settings",
      //   reducers: ["affiliateAccountSettings"],
      // },
    ],
    marketplaces: [walmartIcon, amazonIcon, shopifyIcon],
  },
  {
    icon: wholesaleIcon,
    title: "Wholesale",
    tabs: [
      { title: "Vendors CRM", link: "/vendors", reducers: ["vendors"] },
      {
        title: "Catalog Analyzer",
        link: "/catalog-jobs",
        reducers: ["catalogJobs", "processedCatalogs"],
      },
      { title: "Sales & Profit Report", link: "/sales", reducers: ["sales"] },
      // {
      //   title: "Inventory Management",
      //   link: "/products?tab=amazon",
      //   reducers: ["products", "Products", "pendingPoIndices"],
      // },
    ],
    marketplaces: [amazonIcon],
  },
  {
    icon: twoDWorkflowIcon,
    title: "2D Workflow",
    tabs: [
      {
        title: "Automate Your Inbound Shipments",
        link: "/fba-inbound-new",
        reducers: ["fbaInbound"],
      },
      // { title: "Fba Inbound", link: "/fba-inbound-new", reducers: [""] },
      {
        title: "All Shipments",
        link: "/transport-plans",
        reducers: ["shipments"],
      },
    ],
    marketplaces: [amazonIcon],
  },
  // {
  //   icon: threePLFulfillment,
  //   title: "3PL Fulfillment",
  //   tabs: [
  //   ],
  //   marketplaces: [walmartIcon, amazonIcon, shopifyIcon],
  // },
  // {
  //   icon: inventoryManagementIcon,
  //   title: "Inventory Management",
  //   tabs: [
  //     {
  //       title: "At Amazon/Walmart Inventory",
  //       link: "/products?tab=amazon",
  //       reducers: ["products", "Products", "pendingPoIndices"],
  //     },
  //     {
  //       title: "At 3PL Inventory",
  //       link: "/products?tab=local",
  //       reducers: ["products", "Products", "pendingPoIndices"],
  //     },
  //   ],
  //   marketplaces: [walmartIcon, amazonIcon, shopifyIcon],
  // },
  {
    icon: threePLTools,
    title: "3PL Tools",
    tabs: [
      {
        title: "Manage Storage Locations",
        link: "/home",
        reducers: ["internalStorage"],
      },
      {
        title: "Create New Storage Location",
        link: "/warehouse-location",
        reducers: ["internalStorage"],
      },
      {
        title: "SKU",
        link: "/inventory/sku",
        reducers: ["threeLayerProducts"],
      },
      {
        title: "Products",
        link: "/inventory/products",
        reducers: ["threeLayerProducts"],
      },
      {
        title: "Vendor Items",
        link: "/inventory/vendor",
        reducers: ["threeLayerProducts"],
      },
      {
        title: "PO",
        link: "/po-history",
        reducers: ["pos"],
      },
      {
        title:"PO Warehouse",
        link:"/po-warehouse"
      }
    ],
    marketplaces: [walmartIcon, amazonIcon, shopifyIcon],
  },
  // {
  //   icon: wmsFeatures,
  //   title: "WMS Features",
  //   tabs: [
  //     {
  //       title: "Create New Storage Location",
  //       link: "/warehouse-location",
  //       reducers: ["internalStorage"],
  //     },
  //     {
  //       title: "Manage Storage Locations",
  //       link: "/home",
  //       reducers: ["internalStorage"],
  //     },
  //   ],
  //   marketplaces: [logoSmall],
  // },
  {
    icon: settingsIcon,
    title: "Settings",
    tabs: [
      { title: "Account Integration", link: '/account', reducers: ['account'] },
      { title: "Payment Info", link: '/payments', reducers: ['payment', 'affiliateAccountSettings'] },
      { title: "Users", link: '/users', reducers: ['workers'] },

      // { title: "Subscription Invoice", link: '/subscription-invoices', reducers: ['subscriptionInvoices'] },
      // { title: "Two Steps [Master] Invoice", link: '/two-step-master-invoices', reducers: ['twoStepInvoices'] },
      // { title: "Two Steps Invoice", link: '/two-step-invoices', reducers: ['twoStepInvoices'] },
    ],
    marketplaces: [logoSmall],
  },
];

const MenuDropDown = ({ isDropdownShown, setIsDropdownShown }) => {
  const [navLinksContent, setNavLinksContent] = useState(initialMenuContent);

  const { currentUser: user } = useSelector((state) => state?.auth || {});
  const isOwner = user?.email == "mike@opulent.com";
  const isAdmin = user?.role_id == 1 || user?.role_id == 3;
  const isWarehouseWorker = user?.warehouse_manager_id;
  const isWorker = user?.role_id == 5;
  const isNotSpecialUser = user?.email != "test@sales.support.com";
  const {
    is_public_warehouse,
    is_affiliate_manager_worker,
    is_public_warehouse_worker,
    is_affiliate_manager,
  } = user || {};
  const allowMobileScreens =
    is_public_warehouse ||
    is_public_warehouse_worker ||
    is_affiliate_manager ||
    is_affiliate_manager_worker;
  const allowRemovalPages = is_public_warehouse || is_affiliate_manager;

  useEffect(() => {
    const navLinksContentClone = cloneDeep(initialMenuContent);

    // if (!user?.is_affiliate_manager && !isOwner) {
    //   const index = findIndex(navLinksContentClone, { title: "Agency" });
    //   navLinksContentClone.splice(index, 1);
    // }
    // else {
    //   if (!user?.master_shipment_enabled) {
    //     const index = findIndex(navLinksContentClone, { title: "Agency" });
    //     const tab_index = findIndex(navLinksContentClone[index].tabs, { title: "Settings" });
    //     navLinksContentClone[index].tabs.splice(tab_index, 1);
    //   }
    // }

    // if (!["mikeakrel@gmail.com", "makapakashopify@gmail.com", "steven@dailydistro.com"].includes(user?.email)) {
    //   const index = findIndex(navLinksContentClone, { title: "Distribution (beta)" });
    //   navLinksContentClone.splice(index, 1);
    // }

    // if (isWarehouseWorker || isWorker) {
    //   const whole_sale_index = findIndex(navLinksContentClone, { title: "Wholesale" });
    //   const filteredTabs = filter(navLinksContentClone[whole_sale_index].tabs, (obj) => (['Vendors CRM', 'Sales & Profit Report'].includes(obj.title)))
    //   navLinksContentClone[whole_sale_index].tabs = filteredTabs;

    // }

    // if (!user?.is_owner_warehouse && !user?.email == "mikeakrel@gmail.com") {
    //   const index = findIndex(navLinksContentClone, { title: "3PL Tools" });
    //   navLinksContentClone.splice(index, 1);
    // }

    // if (!allowMobileScreens) {
    //   const index = findIndex(navLinksContentClone, { title: "WMS Features" });
    //   navLinksContentClone.splice(index, 1);
    // }






    // Protected route for warehouse :***************************
    const threePLToolsIndex = findIndex(navLinksContentClone, {
      title: "3PL Tools",
    });
  
    if (threePLToolsIndex !== -1) {
      if (user?.role_id === 3) {
        // Show "Manage Storage Locations", "Create New Storage Location", and "PO Warehouse"
        navLinksContentClone[threePLToolsIndex].tabs = filter(
          navLinksContentClone[threePLToolsIndex].tabs,
          (tab) =>
            ["Manage Storage Locations", "Create New Storage Location", "PO Warehouse"].includes(
              tab.title
            )
        );
      } else {
        // Exclude "PO Warehouse" for other roles
        navLinksContentClone[threePLToolsIndex].tabs = filter(
          navLinksContentClone[threePLToolsIndex].tabs,
          (tab) => tab.title !== "PO Warehouse" && tab.title !== 'Manage Storage Locations' && tab.title !== 'Create New Storage Location'
        );
      }
    }

    // Vendor CRM Check
    const wholesaleTabIndex = findIndex(navLinksContentClone, {
      title: "Wholesale",
    });
  
    if (wholesaleTabIndex !== -1) {
      if (user?.role_id === 3) {
        navLinksContentClone[wholesaleTabIndex].tabs = filter(
          navLinksContentClone[wholesaleTabIndex].tabs,
          (tab) =>
            !["Vendors CRM"].includes(
              tab.title
            )
        );
      }
    }


    // Protected route for warehouse :***************************

    if (!isWorker && !isWarehouseWorker) {
      const settings_index = findIndex(navLinksContentClone, {
        title: "Settings",
      });
      const setting_tabs = cloneDeep(navLinksContentClone[settings_index].tabs);

      if (isAdmin || user?.master_shipment_enabled) {
        setting_tabs.push({
          title: "Shipment [Master] Invoice",
          link: "/invoices",
          reducers: ["customerInvoices", "affiliateAccountSettings"],
        });
      }

      setting_tabs.push(
        {
          title: "Shipment Invoice",
          link: "/user-invoices",
          reducers: ["userInvoices", "affiliateAccountSettings"],
        },
        { title: "Settings Invoice", link: "/invoices/settings", reducers: [] }
      );

      navLinksContentClone[settings_index].tabs = setting_tabs;
      setNavLinksContent(navLinksContentClone);
    }
  }, []);

  return (
    <NavigationDropdown
      key="navigation-dropdown"
      initial={{ y: -250, opacity: 0 }}
      transition={{ type: "spring", stiffness: 100 }}
      animate={isDropdownShown ? { y: 0, opacity: 1 } : { y: -250, opacity: 0 }}
      exit={{ y: -250, opacity: 0, transition: { duration: 0.5 } }}
    >
      {navLinksContent.map((obj, index) => (
        <MenuItem
          key={`item-${index}`}
          obj={obj}
          setIsDropdownShown={setIsDropdownShown}
        />
      ))}

      {/* <HexagonLeft />
      <Triangle />
      <HexagonRight />
      <Bars />
      <Circle /> */}
    </NavigationDropdown>
  );
};

export default MenuDropDown;
